import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Breadcrumb = () => {
  return (
    <nav className="flex items-center space-x-2 text-gray-700 px-16 mt-5">
      <a href="/" className="flex items-center space-x-1 text-blue-500 hover:underline">
        <FontAwesomeIcon icon={faHome} className="h-4 w-4" />
      </a>
      <a href="/dashboard" className="text-blue-500 hover:underline">
        Dashboard
      </a>
      <span className="text-gray-500">•</span>
      <span>Usuarios</span>
    </nav>
  );
};

export default Breadcrumb;